import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoadingService } from './../../services/loading.service';
import { SectionState } from '@shared-features/enums/layout.enum';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  @ViewChild('loadingOverlayPage', { static: true }) loadingOverlayPage: ElementRef;
  isHidden$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(
    private renderer: Renderer2,
    private loadingService: LoadingService
  ) { }

  ngOnInit() {
    this.loadingService.loadingStatus$.subscribe((status: SectionState) => {
      switch (status) {
        case SectionState.HideLoading:
          this.hide();
          break;

        case SectionState.Loading:
          this.showNotTransparent();
          break;

        case SectionState.LoadingTransparent:
          this.showTransparent();
          break;
      }
    });
  }

  showNotTransparent() {
    this.renderer.setStyle(
      this.loadingOverlayPage.nativeElement,
      'background',
      '#FFFFFF'
    );
    this.isHidden$.next(false);
  }

  showTransparent() {
    this.renderer.setStyle(
      this.loadingOverlayPage.nativeElement,
      'background',
      '#40404033'
    );
    this.isHidden$.next(false);
  }

  hide() {
    this.isHidden$.next(true);
    this.renderer.addClass(this.loadingOverlayPage.nativeElement, 'hidden');
  }
}
